import {Repository} from "./Repository";
import {AxiosInstance} from "axios";
import {AppercodeFile} from "../models/File";
import { FilesQueryParametersInterface } from "@api/repositories/interfaces/QueryParametersInterface";

export class FileRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    async create(file: File, name = 'file', storage = '', rights = {READ: true}): Promise<AppercodeFile> {
        return this.client.post<AppercodeFile>(`/files/?fileStore=` + storage, new AppercodeFile({
            name: name,
            shareStatus: "shared",
            rights,
            length: file.size
        }))
            .then(({data}) => {
                return this.upload(data, file);
            });
    }

    async upload(data: any, file: File, config: any = {}): Promise<AppercodeFile> {
        const fd: FormData = new FormData();
        fd.append('file', file);

        return this.client.post(`/files/` +  data.id + `/upload`, fd, {
            headers : {
                'Content-Type' : 'multipart/form-data'
            },
            ...config
        })
            .then(() => {
                return new AppercodeFile(data);
            });
    }

    async get(id: string): Promise<AppercodeFile> {
        return this.client.get<AppercodeFile>(`/files/` + id)
            .then(({data}) => {
                return new AppercodeFile(data);
            });
    }

    async update(id: string, data: any): Promise<AppercodeFile> {
        return this.client.put<AppercodeFile>(`/files/` + id, data)
            .then(({data}) => {
                return new AppercodeFile(data);
            });
    }

    async delete(id: string): Promise<boolean> {
        return this.client.delete<boolean, boolean>(`/files/${id}`)
    }

    async query(query: FilesQueryParametersInterface = {}): Promise<AppercodeFile[]> {
        return this.client.post(`/files/query`, query)
            .then(({data}) => {
                return data.map((file: { [key: string]: any })  => new AppercodeFile(file));
            });
    }

    async getFile(url: string) {
       return await this.client.get(url, { responseType: "blob" });
    }
}
